export const H6_BASE_CSS_VARS = {
  "theme-website-h6-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-h6-font-family": "InterVariable",
  "theme-website-h6-font-size": "1.375rem",
  "theme-website-h6-font-weight": "400",
  "theme-website-h6-line-height": "1.4",
  "theme-website-h6-letter-spacing": "0",
};
